import btecToken from "../abis/development/tokens/btecToken";

export default {
  name: "BTECT",
  abi: btecToken.abi,
  contractAddress: "0x712007201d05b895742dcbdaf7dab74075568805",
  decimals: 9,
};
